import {es} from './languages'


function translate(text: string, language: string): string {
    if (language === 'es') {
        return es[text] || text;
    }
    return text;
}



export function getTranslationsForTable(data: any[], language: 'es', fieldsToTranslate: string[]): any[] {
  return data.map(item => {
    const translatedItem = { ...item };
    fieldsToTranslate.forEach(field => {
      if (item[field]) {
        translatedItem[field] = translate(item[field], language);
      }
    });
    return translatedItem;
  });
}